import  gql  from 'graphql-tag'

export const CREATE_OFFICE = gql`mutation office($input: OfficeMutationInput!){
    office(input: $input){
        office{
            id
            code
            name
            email
            isActive
            regional{
                id
                code
                name
            }
        }
        errors{
            field
            messages
        }
    }
}`;